document.addEventListener('DOMContentLoaded', function () {
    setTimeout(() => {
        document.dispatchEvent(new CustomEvent('cartOpen'));
    }, 1000);

    // Tracks the last pincode that completed a successful validation this session.
    // Persists across cart re-renders (add/remove/modify) since it lives in JS memory,
    // not in the DOM. Reset to null only on page reload.
    let lastValidatedPincode = null;

    // ─── Restore pincode UI state ─────────────────────────────────────────────
    // Called whenever the cart drawer re-renders to bring back the checkout
    // button and serviceability message without re-hitting the Hasura API.
    function restorePincodeUI(pincode) {
        const pincodeInput = document.getElementById('pincodeInputcheckout');
        if (pincodeInput && !pincodeInput.value.trim()) {
            pincodeInput.value = pincode;
        }

        const checkoutButton = document.getElementById('CartDrawer-Checkout');
        if (checkoutButton) {
            checkoutButton.style.display = 'block';
            checkoutButton.disabled = false;
        }

        const pincodeResponseElement = document.getElementById('pincodeResponse');
        if (pincodeResponseElement) {
            pincodeResponseElement.innerHTML = `<p style="color: green;">All products are serviceable to this pincode.</p>`;
        }
    }

    // ─── Lock checkout when pincode input changes ─────────────────────────────
    // Uses event delegation so this survives cart re-renders that replace the DOM.
    document.addEventListener('input', function (event) {
        if (!event.target || event.target.id !== 'pincodeInputcheckout') return;
        const currentValue = event.target.value.trim();
        // If the user types anything different from the validated pincode,
        // lock checkout immediately until they re-validate.
        if (currentValue !== lastValidatedPincode) {
            const checkoutButton = document.getElementById('CartDrawer-Checkout');
            if (checkoutButton) {
                checkoutButton.style.display = 'none';
                checkoutButton.disabled = true;
            }
            const pincodeResponseElement = document.getElementById('pincodeResponse');
            if (pincodeResponseElement) pincodeResponseElement.innerHTML = '';
        } else {
            // User typed back the validated pincode — restore immediately.
            restorePincodeUI(currentValue);
        }
    });

    // ─── Custom event: pincode-value-changed ─────────────────────────────────
    // Single gate for all validation. Code dispatches this event instead of
    // calling handlePincodeCheck() directly.
    function dispatchPincodeChanged(pincode) {
        document.dispatchEvent(new CustomEvent('pincode-value-changed', {
            detail: { pincode }
        }));
    }

    document.addEventListener('pincode-value-changed', function (e) {
        handlePincodeCheck(e.detail.pincode);
    });

    // ─── Cart drawer open (fires on every cart re-render too) ────────────────
    document.addEventListener('cartOpen', async function () {

        const headerMessageElement = document.getElementById('headerPincodeMessage');
        const headerMessageMobileElement = document.getElementById('headerPincodeMessagemobile');

        if (lastValidatedPincode) {
            // Already validated this session (e.g. cart item was added/removed/changed).
            // Restore UI immediately from memory — no network call needed.
            updateHeaderMessages(lastValidatedPincode, headerMessageElement, headerMessageMobileElement);
            restorePincodeUI(lastValidatedPincode);
            return;
        }

        // First open after page load — check if a pincode was validated in a
        // previous session and is stored in cart attributes.
        const savedPincode = await getCartAttribute('checked_pincode');
        console.log("Saved Pincode from Cart:", savedPincode);

        if (savedPincode) {
            const pincodeInput = document.getElementById('pincodeInputcheckout');
            if (pincodeInput) pincodeInput.value = savedPincode;

            // Don't blindly trust the stored attribute — re-run the real Hasura +
            // per-product check. Cart contents can change between sessions, and a
            // stale/incorrect value could already be sitting in the attribute.
            // handlePincodeCheck() will only (re)save/display it as serviceable if
            // it actually passes.
            dispatchPincodeChanged(savedPincode);
        } else {
            // First time — no saved pincode. Keep checkout locked until user validates.
            console.log("No saved pincode found in cart attributes.");
            const checkoutButton = document.getElementById('CartDrawer-Checkout');
            if (checkoutButton) {
                if (window.pincodeValidationEnabled === 'yes') {
                    checkoutButton.disabled = true;
                } else {
                    checkoutButton.disabled = false;
                    checkoutButton.style.display = 'block';
                }
            }
        }
    });

    // ─── Manual check button ─────────────────────────────────────────────────
    // User explicitly pressed "Check Pincode" — always validate regardless of
    // whether the value matches the last validated pincode.
    document.addEventListener("click", function (event) {
        if (event.target && event.target.id === "checkPincodeButtoncheckout") {
            const pincode = document.getElementById('pincodeInputcheckout')?.value.trim();
            if (pincode) {
                lastValidatedPincode = null; // force re-validation
                dispatchPincodeChanged(pincode);
            }
        }
    });

    // Uses event delegation so Enter-to-validate survives cart re-renders.
    document.addEventListener('keypress', function (event) {
        if (event.target && event.target.id === 'pincodeInputcheckout' && event.key === 'Enter') {
            event.preventDefault();
            document.getElementById("checkPincodeButtoncheckout")?.click();
        }
    });

    // ─── Cart mutations ───────────────────────────────────────────────────────
    // cart-updated and cart-remove fire before the DOM re-renders, so there is
    // nothing to restore here — the cartOpen event (fired by renderContents →
    // open()) handles restoration after the re-render completes.
    // These listeners only trigger a fresh validation if the pincode changed.
    function revalidateIfPincodeChanged() {
        const pincodeInput = document.getElementById("pincodeInputcheckout");
        const currentPincode = pincodeInput?.value.trim();
        if (currentPincode && currentPincode.length === 6 && currentPincode !== lastValidatedPincode) {
            dispatchPincodeChanged(currentPincode);
        }
    }

    document.addEventListener('cart-remove', function () {
        revalidateIfPincodeChanged();
    });

    document.addEventListener('cart-updated', function () {
        revalidateIfPincodeChanged();
    });

    // ─── Validation logic ─────────────────────────────────────────────────────
    async function handlePincodeCheck(overridePincode = null) {
        console.log("Pincode Check Triggered");

        document.getElementById('pincodeLoader').style.display = 'flex';

        const enteredPincode = overridePincode || document.getElementById('pincodeInputcheckout').value.trim();
        console.log("Entered Pincode:", enteredPincode);

        if (!enteredPincode) {
            alert("Please enter a valid pincode.");
            document.getElementById('pincodeLoader').style.display = 'none';
            return;
        }

        let anyProductNotAvailable = false;
        document.querySelectorAll('.pincodeResponsed').forEach(element => element.innerHTML = '');

        const pincodeGroup = await fetchPincodeGroup(enteredPincode);
        console.log("Pincode validation - group(s) used for this check:", pincodeGroup);
        if (!pincodeGroup) {
            document.getElementById('pincodeResponse').innerHTML = `<p style="color: red;">Sorry, we do not deliver to this area.</p>`;
            clearHeaderMessages(document.getElementById('headerPincodeMessage'), document.getElementById('headerPincodeMessagemobile'));
            document.getElementById('pincodeLoader').style.display = 'none';
            return;
        }

        document.querySelectorAll('.cart-item__details').forEach((productItem) => {
            const pincodeMessageElement = productItem.querySelector('.pincodeResponsed');
            const hiddenFieldElement = productItem.querySelector('#pincodevarient');
            let hiddenField = hiddenFieldElement ? hiddenFieldElement.value.trim() : '';
            let allowedPincodes = hiddenField ? JSON.parse(hiddenField) : [];

            const isPincodeAvailable = allowedPincodes.length === 0 || allowedPincodes.some(group => pincodeGroup.includes(group));
            console.log("Pincode validation - product check:", { allowedPincodes, pincodeGroup, isPincodeAvailable });
            pincodeMessageElement.innerHTML = isPincodeAvailable
                ? `<p style="color: green;">This product is available for your area.</p>`
                : `<p style="color: red;">Sorry, this product is not available in your area.</p>`;
            if (!isPincodeAvailable) anyProductNotAvailable = true;
        });

        const pincodeResponseElement = document.getElementById('pincodeResponse');
        const checkoutButton = document.getElementById('CartDrawer-Checkout');

        if (!anyProductNotAvailable) {
            // Only persist the pincode once it has actually been validated as serviceable.
            await updateCartAttribute('checked_pincode', enteredPincode);
            checkoutButton.style.display = 'block';
            checkoutButton.disabled = false;
            if (pincodeResponseElement) pincodeResponseElement.innerHTML = `<p style="color: green;">All products are serviceable to this pincode.</p>`;
            updateHeaderMessages(enteredPincode, document.getElementById('headerPincodeMessage'), document.getElementById('headerPincodeMessagemobile'));

            // Record the validated pincode so future events with the same value are skipped.
            lastValidatedPincode = enteredPincode;
        } else {
            checkoutButton.style.display = 'none';
            checkoutButton.disabled = true;
            if (pincodeResponseElement) pincodeResponseElement.innerHTML = `<p style="color: red;">Some products are not serviceable in this area. Please remove them to proceed.</p>`;
            clearHeaderMessages(document.getElementById('headerPincodeMessage'), document.getElementById('headerPincodeMessagemobile'));

            // Not serviceable — do not mark as validated, so re-entering it or
            // changing the cart triggers a fresh check instead of being skipped.
            lastValidatedPincode = null;
        }

        document.getElementById('pincodeLoader').style.display = 'none';
    }

    // ─── Cart attribute helpers ───────────────────────────────────────────────
    async function updateCartAttribute(attributeName, value) {
        try {
            const response = await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    attributes: {
                        [attributeName]: value,
                        pincode: value
                    }
                })
            });
            const result = await response.json();
            return result.attributes?.[attributeName] || null;
        } catch (error) {
            return null;
        }
    }

    async function getCartAttribute(attributeName) {
        try {
            const response = await fetch('/cart.js');
            const cart = await response.json();
            console.log("Cart Data:", cart);
            return cart.attributes?.[attributeName] || null;
        } catch (error) {
            console.error('Error fetching cart attribute:', error);
            return null;
        }
    }

    function updateHeaderMessages(pincode, desktopElement, mobileElement) {
        if (desktopElement) {
            desktopElement.textContent = `Delivering to: ${pincode}`;
            desktopElement.style.display = 'block';
        }
        if (mobileElement) {
            mobileElement.textContent = `Delivering to: ${pincode}`;
            mobileElement.style.display = 'block';
        }
    }

    function clearHeaderMessages(desktopElement, mobileElement) {
        if (desktopElement) {
            desktopElement.textContent = '';
            desktopElement.style.display = 'none';
        }
        if (mobileElement) {
            mobileElement.textContent = '';
            mobileElement.style.display = 'none';
        }
    }

    async function fetchPincodeGroup(pincode) {
        try {
            const response = await fetch('https://hasura.livealtlife.com/v1/graphql', {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    'x-hasura-admin-secret': 'JLl1ngn5AN'
                },
                body: JSON.stringify({
                    query: `
                        query getPinGroup($pincode: Int) {
                            non_ecom_pincode(where: {pincode: {_eq: $pincode}}) {
                                pincode_group
                            }
                        }
                    `,
                    variables: { pincode: parseInt(pincode) }
                })
            });

            const result = await response.json();
            console.log("Hasura pincode validation - raw response:", result);
            const groups = result.data?.non_ecom_pincode.map(item => item.pincode_group) || [];
            console.log("Hasura pincode validation - resolved pincode_group(s):", groups);
            return groups;
        } catch (error) {
            console.error('Error fetching pincode group:', error);
            return null;
        }
    }
});
